export interface Theme {
  [key: string]: {
    backgroundColor: string;
    fontColor: string;
  };
}

const themes: Theme = {
  'light-grey': {
    backgroundColor: '#cccccc',
    fontColor: '#ffffff'
  },
  blue: {
    backgroundColor: '#366BF3',
    fontColor: '#ffffff'
  },
  turquoise: {
    backgroundColor: '#71c6b1',
    fontColor: '#ffffff'
  },
  'light-green': {
    backgroundColor: '#b1c42d',
    fontColor: '#ffffff'
  },
  'light-blue': {
    backgroundColor: '#99c6d9',
    fontColor: '#ffffff'
  },
  green: {
    backgroundColor: '#21D196',
    fontColor: '#ffffff'
  },
  violet: {
    backgroundColor: '#4f0b82',
    fontColor: '#ffffff'
  },
  plumb: {
    backgroundColor: '#930d51',
    fontColor: '#ffffff'
  },
  'light-pink': {
    backgroundColor: '#cc9e9d',
    fontColor: '#ffffff'
  },
  red: {
    backgroundColor: '#ff4d3a',
    fontColor: '#ffffff'
  },
  orange: {
    backgroundColor: '#ffc520',
    fontColor: '#363636'
  }
};

export default themes;
